import { render } from "./indextwelvebanner.vue?vue&type=template&id=18566643"
import script from "./indextwelvebanner.vue?vue&type=script&lang=js"
export * from "./indextwelvebanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__